import { Title, Stack, Group } from "@mantine/core"
import { RingProgress, InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { ActivityProgressIcon } from "~/pages/SupplierPortal/TraceabilityRequests/components/ActivityProgressIcon"
import { OperationItem } from "~/pages/SupplierPortal/TraceabilityRequests/utils"
import { useGetOperations } from "~/utils/operations"

export const OperationNotCreated = ({
  operationItem,
}: {
  operationItem: OperationItem
}) => {
  const operation = useGetOperations()[operationItem.activityName]
  const { t } = useTranslation("traceability")
  return (
    <Stack>
      <Group align="center" w="100%">
        <RingProgress
          size={40}
          roundCaps
          styles={{
            label: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          }}
          thickness={4}
          sections={[{ value: 100, color: "var(--mantine-color-error)" }]}
          label={
            <ActivityProgressIcon
              progress={0}
              activityName={operationItem.activityName}
              size={20}
            />
          }
        />
        <Title size={14} order={5}>
          {operation?.name}
        </Title>
      </Group>
      <InfoBox
        variant="error"
        title={t("operationNotCreated")}
        message={t("operationNotCreatedMessage")}
      />
    </Stack>
  )
}
